import { createPostedNote, deletePostedNote, editPostedNote, getPostedNote } from './postedNote.action';

export { postedNoteReducer } from './postedNote.reducer';
export { watchPostedNote } from './postedNote.saga';

export const postedNoteActions = {
    getPostedNote,
    createPostedNote,
    editPostedNote,
    deletePostedNote,
};
